import axios from "axios";
import "./CustomerSummary.css";
import { useDispatch, useSelector } from "react-redux";
import { customerSummary } from "../../slices/customerSlice";
import {
  setSelectedCustomerDetail,
  setSelectedCustomerSummaryFilters,
  resetCustomerSummaryFilters,
} from "../../slices/customerSlice";
import Header from "../../components/Header/header";
import { useEffect, useState, useRef } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Footer from "../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
// import SubLoader from "../../components/SubLoader/SubLoader";
import { confirmToast } from "../../components/ConfirmToast/ConfirmToast";
import { formatGermanInputForDecimal } from "../../utility/NumberFormat";
import { toast } from "react-toastify";
import MultiSelect from "../../components/MultiSelect/MultiSelect";



const CustomerSummary = () => {
  const filters = useSelector(
    (state) => state.customer.selectedCustomerSummaryFilters
  );

  const updateFilter = (key, value) => {
    dispatch(
      setSelectedCustomerSummaryFilters({
        key,
        value,
      })
    );
  }

  const [pageNo, setPageNo] = useState(0);
  const [isLoadingCustDetails, setIsLoadingCustDetails] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableHandler, setAvailableHandler] = useState([]);
  const [availableKdNumber, setAvailableKdNumber] = useState([]);

  const [availableLand, setAvailableLand] = useState([]);

  const [customerSummaryTemplateData, SetcustomerSummaryTemplateData] =
    useState([]);

  const [tableCheckbox, setTableCheckbox] = useState({});
  // console.log("tableCheckbox", tableCheckbox)
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  // console.log("isSelectAllChecked", isSelectAllChecked)
  // const [bodyDataAllocateTemplate, setBodyDataAllocateTemplate] = useState([]);
  const [availableActive, setAvailableActive] = useState([]);
  const [vtr, setVtr] = useState([]);
  // console.log("vtr", vtr)
  const [vtrGroup, setVtrGroup] = useState([]);

  const userCheckName = localStorage.getItem("username");

  const checkedRows = Object.entries(tableCheckbox)
    .filter(([key, item]) => item.checked)
    .map(([key, item]) => ({
      index: Number(key),
      data: item,
    }));

  const authToken = localStorage.getItem("authToken");
  const userProfile = localStorage.getItem("userProfile");
  const parsedUser = JSON.parse(userProfile);
  // console.log("parsedUser", parsedUser)
  const [totalEK, setTotalEk] = useState(0);
  const [totalVK, setTotalVk] = useState(0);
  const scrollRef = useRef(null);
  // const [currentTime, setCurrentTime] = useState(Date.now());
  // const LockTime = Number(localStorage.getItem("planningLock"));



  // redux code
  const customerDetails = useSelector(
    (state) => state.customer.customerDetails
  );

  const selectedCustomer = useSelector(
    (state) => state.customer.selectedCustomerDetail
  );

  // navigate code

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ✅ Run ONCE on first load
  const initialLoadDone = useRef(false);

  useEffect(() => {
    if (!initialLoadDone.current) {
      initialLoadDone.current = true;
      customerData(0);
      dropDownFunction();
      getTotals();
    }
  }, []);

  const didMount = useRef(false);
  // ✅ Get total EK + VK
  const getTotals = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/getTotalCustDetail?year=${filters.selectedYear}&cust=${filters.selectedLand}&div=${filters.selectedHandler}&active=${filters.selectedActive}&soldTo=${filters.selectedKdNumber}&typ=${filters.selectedType}&vtrFilter=${filters.selectedVtr}&vtrGroupFilter=${filters.selectedVtrGroup}&handlerName=${filters.handlerName}&planning=${filters.selectedOldCustomer}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = res.data;
      setTotalEk(data.totalBuying || "");
      setTotalVk(data.totalSelling || "");
    } catch (err) {
      console.error("Error fetching totals:", err);
      setTotalEk(0);
      setTotalVk(0);
    }
  };

  const debounceRef = useRef(null);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    // debounce only for handlerName typing
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    const isTyping = filters.handlerName !== "";

    if (isTyping) {
      debounceRef.current = setTimeout(() => {
        setPageNo(0);
        customerData(0);
        getTotals();
        dropDownFunction();
      }, 1500);
    } else {
      setPageNo(0);
      customerData(0);
      getTotals();
      dropDownFunction();
    }

    return () => clearTimeout(debounceRef.current);
  }, [
    filters.selectedYear,
    filters.selectedHandler,
    filters.selectedKdNumber,
    filters.selectedLand,
    filters.selectedActive,
    filters.selectedType,
    filters.selectedVtr,
    filters.selectedVtrGroup,
    filters.selectedPlanned,
    filters.handlerName,
    filters.selectedOldCustomer,
  ]);

  // Only fetch data for scroll-triggered pageNo change
  const pageEffectRanOnce = useRef(false);
  const hasMoreRef = useRef(true);

  useEffect(() => {
    if (!pageEffectRanOnce.current) {
      pageEffectRanOnce.current = true;
      return; // skip first run
    }
    customerData(pageNo);
  }, [pageNo]);

  const isFetchingRef = useRef(false);

  const lastScrollTop = useRef(0);

  const handleInfinityScroll = () => {
    const container = scrollRef.current;
    if (!container || isFetchingRef.current || !hasMoreRef.current) return;

    // ignore horizontal scroll
    if (container.scrollTop === lastScrollTop.current) return;

    lastScrollTop.current = container.scrollTop;

    const { scrollTop, clientHeight, scrollHeight } = container;
    const nearBottom = scrollTop + clientHeight >= scrollHeight - 20;

    if (nearBottom) {
      isFetchingRef.current = true;
      setPageNo((prev) => prev + 1);
    }
  };

  // ✅ Handle Dropdowns
  const dropDownFunction = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/dropDownArraysForCustomerSummaryUpdated?year=${filters.selectedYear}&soldTo=${filters.selectedKdNumber}&div=${filters.selectedHandler}&pTyp=${filters.selectedType}&cust=${filters.selectedLand}&active=${filters.selectedActive}&vtr=${filters.selectedVtr}&vtrGroup=${filters.selectedVtrGroup}&planning=${filters.selectedOldCustomer}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const data = response.data;

      if (Array.isArray(data.actives)) {
        setAvailableActive(data.actives);
      }
      if (Array.isArray(data.custs)) setAvailableLand(data.custs);
      if (Array.isArray(data.divs)) setAvailableHandler(data.divs);
      if (Array.isArray(data.years)) setAvailableYears(data.years.reverse());
      if (Array.isArray(data.soldTos)) setAvailableKdNumber(data.soldTos);
      if (Array.isArray(data.vtrs)) setVtr(data.vtrs);
      if (Array.isArray(data.vtrGroups)) setVtrGroup(data.vtrGroups);
    } catch (error) {
      console.error("API error:", error);
    }
  };

  // ✅ Get customer data
  const customerData = async (page = pageNo) => {
    // console.log("selected type", selectedType);
    // updateFilter("selectedTemplate", "");
    if (page === 0) {
      updateFilter("selectedTemplate", "");
    }
    hasMoreRef.current = true;
    setIsLoadingCustDetails(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/getCustDetail?items=30&pageNo=${page}&year=${filters.selectedYear}&cust=${filters.selectedLand}&div=${filters.selectedHandler}&active=${filters.selectedActive}&soldTo=${filters.selectedKdNumber}&typ=${filters.selectedType}&vtrFilter=${filters.selectedVtr}&vtrGroupFilter=${filters.selectedVtrGroup}&planned=${filters.selectedPlanned}&handlerName=${filters.handlerName}&planning=${filters.selectedOldCustomer}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      // console.log("res", res)

      const newData = res.data || [];

      // console.log("nw data check", newData);

      if (page === 0) {
        dispatch(customerSummary(newData)); // ✅ replace
      } else {
        dispatch(customerSummary([...customerDetails, ...newData])); // ✅ append
      }
      if (newData.length < 30) {
        hasMoreRef.current = false;
      }

      // console.log("newData",newData)
      // Auto select newly loaded rows when Select All is checked
      if (page > 0 && isSelectAllChecked) {
        const currentLength = customerDetails.length;

        setTableCheckbox((prev) => {
          const updatedCheckbox = { ...prev };

          newData.forEach((row, idx) => {
            const shouldUncheck =
              filters.selectedTemplate &&
              row.jahresVk != null &&
              row.jahresVk !== 0;

            if (!shouldUncheck) {
              updatedCheckbox[currentLength + idx] = {
                checked: true,
                soldTo: row.soldTo,
                planYear: row.year,
                division: row.div,
                shipTo: row.shipTo,
              };
            }
          });

          return updatedCheckbox;
        });

        // setBodyDataAllocateTemplate((prev) => {
        //   const newRows = [];

        //   newData.forEach((row) => {
        //     const shouldUncheck =
        //       filters.selectedTemplate &&
        //       row.jahresVk !== null &&
        //       row.jahresVk !== 0;

        //     if (!shouldUncheck) {
        //       newRows.push({
        //         soldTo: row.soldTo,
        //         shipTo: row.shipTo,
        //         div: row.div,
        //         year: row.year,
        //         templateDes:
        //           customerSummaryTemplateData.find(
        //             (item) => item.soldTo === filters.selectedTemplate
        //           )?.description || "",
        //       });
        //     }
        //   });

        //   return [...prev, ...newRows];
        // }
        // );
      }

      // setTableCheckbox({});
      // setBodyDataAllocateTemplate([]);

      if (page === 0) {
        setTableCheckbox({});
        // setBodyDataAllocateTemplate([]);
        setIsSelectAllChecked(false);
      }

      // setTimeout(() => {
      //   if (scrollRef.current) {
      //     scrollRef.current.scrollTop -= 100;
      //   }
      // }, 100);
    } catch (err) {
      console.log("Error while fetching customer data:", err);
    } finally {
      isFetchingRef.current = false;
      setIsLoadingCustDetails(false);
    }
  };

  // console.log('table check bnox', tableCheckbox)

  // reset btn remove all filter

  const getResetValue = async () => {
    const confirm = await confirmToast(
      "Are you sure you want to reset all the fields?"
    );

    if (!confirm) return;

    // setFilters(defaultFilters);
    // dispatch(setSelectedCustomerSummaryFilters(defaultFilters));
    dispatch(resetCustomerSummaryFilters());

    setTableCheckbox({});
    setIsSelectAllChecked(false); // <-- Add this line
    setPageNo(0);
  };

  // delete multiple planning
  const deleteMultiplePlannings = async () => {
    // selected rows data
    const filterData = checkedRows.map((item) => ({
      soldTo: item.data.soldTo,
      planYear: item.data.planYear,
      division: item.data.division,
      shipTo: item.data.shipTo,
    }));

    // const soldToList = filterData.map(item => item.soldTo);

    const soldToShipToList = filterData.map(
      (item) => `${item.soldTo} / ${item.shipTo ? ` ${item.shipTo}` : ""}`
    );

    // console.log("soldToShipToList", soldToShipToList);

    // no select checkboxes
    if (Object.keys(soldToShipToList).length === 0) {
      toast.error(
        "First you have to select Checkbox then delete any  planning"
      );
      return;
    }

    try {
      // confirm popup
      const confirmDelete = await confirmToast(
        // `Are you sure you want to Delete this Kdno.${soldToList} Planning?`,
        `Are you sure you want to delete the planning data for KD No. ${soldToShipToList.join(
          ",  "
        )}?`
      );

      // NO click -> stop function
      if (!confirmDelete) {
        return;
      }

      setIsLoadingDelete(true);

      // delete api
      const res = await axios.delete(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/deleteMultiplePlannings`,
        {
          data: {
            entries: filterData,
            // entries: filterDataWithJahresVk,
          },
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // redux table update instantly
      const updatedData = customerDetails.filter(
        (row) =>
          !filterData.some(
            (item) =>
              item.soldTo === row.soldTo &&
              item.planYear === row.year &&
              item.division === row.div &&
              item.shipTo === row.shipTo
          )
      );

      // redux update
      dispatch(customerSummary(updatedData));

      // clear checkbox
      setTableCheckbox({});
      await customerData(0);

      toast.success("Deleted Successfully");
    } catch (error) {
      console.log("Delete Error", error.response?.data);

      toast.error(error.response?.data.message);
    } finally {
      setIsLoadingDelete(false);
    }
  };

  //onSave template api payload function
  const getAllocateTemplatePayload = () => {
    const selectedItem = customerSummaryTemplateData.find(
      (item) => item.soldTo === filters.selectedTemplate
    );

    return customerDetails
      .filter((row, index) => tableCheckbox[index]?.checked)
      .map((row) => ({
        soldTo: row.soldTo,
        shipTo: row.shipTo,
        div: row.div,
        year: row.year,
        templateDes: selectedItem?.description || "",
      }));
  };

  //  template save edit btn Function
  const onSaveTemplate = async () => {
    // template empty check
    if (!filters.selectedTemplate) {
      toast.error("First you have to select template then save the planning");
      return;
    }

    const payload = getAllocateTemplatePayload();

    const soldToList = payload
      ?.map((item) => `${item.soldTo}/${item.shipTo}`)
      .join(", ");
    // console.log("soldToList on save ",soldToList)
    // return;

    if (payload.length < 1) {
      return toast.error("Nothing is selected. Please select");
    }

    // confirm popup
    const confirmSave = await confirmToast(
      // `Are you sure you want to Save this KdNo ${soldToList} Planning?`,
      `Are you sure you want to save the selected planning records for KD No. ${soldToList}?`
    );

    // NO click
    if (!confirmSave) {
      return;
    }

    setIsLoadingSave(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/allocateTemplate`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // console.log("Response:", res.data);

      // success toast
      toast.success("Template allocated successfully");

      // TABLE REFRESH
      await customerData(0);

      updateFilter("selectedTemplate", "");
      setTableCheckbox({});
      // setBodyDataAllocateTemplate([]);
    } catch (error) {
      console.log("Error:", error);

      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoadingSave(false);
    }
  };

  const handleTemplateChange = async (year) => {
    // setIsLoadingChoosetemplate(true);
    // setIsError(false); // reset
    try {
      let url = `${process.env.REACT_APP_API_LINK}/api/v1/entry/getUniqTempSoldTo`;
      if (year) {
        url += `?year=${year}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      // console.log("API Response:", response.data.data);
      SetcustomerSummaryTemplateData(response.data.data);
      //  Send API data to Redux
      // dispatch(setTemplateData(response.data.data));
    } catch (error) {
      console.error("Error fetching templates:", error);
      // setIsError(true); // ❗ error track karo
    } finally {
      // setIsLoadingChoosetemplate(false);
    }
  };

  useEffect(() => {
    // if (selectedYear) {
    handleTemplateChange(filters.selectedYear);
    // }
  }, [filters.selectedYear]);

  // table head  checkbox function
  const handleSelectAllCheckboxes = (e) => {
    const checked = e.target.checked;
    console.log("handleSelectAllCheckboxes checked", checked);

    return;

    setIsSelectAllChecked(checked);

    const updatedCheckbox = {};
    // let bodyArray = [];

    //  rows count
    const alreadyCreatedRows = customerDetails.filter(
      (row) =>
        filters.selectedTemplate && row.jahresVk !== null && row.jahresVk !== 0
    );

    const alreadyCreatedSoldTo = alreadyCreatedRows.map((row) => row.soldTo);

    //  Toast Error
    if (checked && alreadyCreatedRows.length > 0) {
      toast.error(
        // "Some KD No already have VK Planning created, so checkbox cannot be selected.",
        `VK Planning has already been created for the following KD No.  ${alreadyCreatedSoldTo.join(
          ", "
        )}. Therefore, these records cannot be selected.`,
        {
          toastId: "vk-planning-exist",
        }
      );
    }

    // customerDetails.forEach((row, index) => {
    //   const shouldUncheck =
    //     filters.selectedTemplate &&
    //     row.jahresVk !== null &&
    //     row.jahresVk !== 0;

    //   updatedCheckbox[index] = {
    //     checked: shouldUncheck ? false : checked,

    //     soldTo: row.soldTo,
    //     planYear: row.year,
    //     division: row.div,
    //     shipTo: row.shipTo,
    //   };

    //   //  only allowed rows
    //   if (checked && !shouldUncheck) {
    //     bodyArray.push({
    //       soldTo: row.soldTo,
    //       shipTo: row.shipTo,
    //       div: row.div,
    //       year: row.year,
    //       templateDes:
    //         customerSummaryTemplateData.find(
    //           (item) =>
    //             item.soldTo ===
    //             filters.selectedTemplate,
    //         )?.description || "",
    //     });
    //   }
    // });

    customerDetails.forEach((row, index) => {
      const shouldUncheck =
        filters.selectedTemplate && row.jahresVk !== null && row.jahresVk !== 0;

      if (shouldUncheck) {
        return; // state me add hi mat karo
      }

      updatedCheckbox[index] = {
        checked,
        soldTo: row.soldTo,
        planYear: row.year,
        division: row.div,
        shipTo: row.shipTo,
        jahresVk: row.jahresVk, // add state jahresVk value
      };

      // if (checked) {
      //   bodyArray.push({
      //     soldTo: row.soldTo,
      //     shipTo: row.shipTo,
      //     div: row.div,
      //     year: row.year,
      //     templateDes:
      //       customerSummaryTemplateData.find(
      //         (item) => item.soldTo === filters.selectedTemplate
      //       )?.description || "",
      //   });
      // }
    });

    setTableCheckbox(updatedCheckbox);

    // setBodyDataAllocateTemplate(
    //   checked ? bodyArray : [],
    // );
  };

  //  table inside checkboxe function
  const handleSelectCheckboxes = (e, row, index) => {
    e.stopPropagation();

    if (
      filters.selectedTemplate &&
      row.jahresVk !== null &&
      row.jahresVk !== 0
    ) {
      return;
    }

    const checked = e.target.checked;

    setTableCheckbox((prev) => ({
      ...prev,
      [index]: {
        checked: checked,
        soldTo: row.soldTo,
        planYear: row.year,
        division: row.div,
        shipTo: row.shipTo,
        jahresVk: row.jahresVk, // add state jahresVk value
      },
    }));

    const selectedItem = customerSummaryTemplateData.find(
      (item) => item.soldTo === filters.selectedTemplate
    );

    // const newObject = {
    //   soldTo: row.soldTo,
    //   shipTo: row.shipTo,
    //   div: row.div,
    //   year: row.year,
    //   templateDes:
    //     selectedItem?.description || "",
    // };

    // if (checked) {
    //   setBodyDataAllocateTemplate((prev) => [
    //     ...prev,
    //     newObject,
    //   ]);
    // } else {
    //   setBodyDataAllocateTemplate((prev) =>
    //     prev.filter(
    //       (item) =>
    //         !(
    //           item.soldTo === row.soldTo &&
    //           item.shipTo === row.shipTo &&
    //           item.div === row.div
    //         ),
    //     ),
    //   );
    // }
  };

  const handleSelectCustomer = async (row) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_LINK}/api/v1/entry/checkLock`,
        {
          params: {
            soldTo: row.soldTo,
            shipTo: row.shipTo,
            planYear: row.year,
            division: row.div,
          },
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      // console.log("data locked?", data);
      // console.log("selected customer?", selectedCustomer);

      if (data.locked && userCheckName !== data.data?.username) {
        toast.error(
          `This planning is currently in use by ${data.data?.username || "another user"
          }.`
        );
        return;
      }

      // VK Planning
      if (row.pTyp === "VK" && parsedUser?.vkPlanning === true) {
        const shipTo = row.shipTo || "blank";
        const cty = row.cty || "blank";
        const customerName = row.name || "blank";
        const vtr = row.vtr || "blank";
        const isEditable = row.isEditable || "blank";

        if (
          selectedCustomer &&
          selectedCustomer?.isLockPlanning === true &&
          data.locked === false
        ) {
          // toast.remove();
          toast.error("You already have a planning open. Release it first.");
          return;
        }

        dispatch(setSelectedCustomerDetail({ ...row, isLockPlanning: true }));

        navigate(
          `/vk-planning/${row.soldTo}/${shipTo}/${row.year}/${row.div}/${cty}/${customerName}/${vtr}/${isEditable}`
        );
        return;
      }

      // EK Planning
      if (row.pTyp === "EK" && parsedUser?.ekPlanning === true) {
        navigate(`/ek-planning/${row.soldTo}`);
        return;
      }

      toast.error(<strong>You cannot access this Tab.</strong>, {
        toastId: "no-access",
      });
    } catch (error) {
      console.error("Error checking lock:", error);
      toast.error("Unable to verify lock status.");
    }
  };

  // console.log("selected customer", selectedCustomer);


  // useEffect(() => {
  //   if (!LockTime) return;

  //   const interval = setInterval(() => {
  //     const now = Date.now();
  //     setCurrentTime(now);

  //     if (now >= LockTime) {
  //       localStorage.removeItem("planningLock");
  //       clearInterval(interval);
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [LockTime]);



  return (
    <>
      <div className="main_container">
        {/* <div >
        <Header />
        </div> */}
        <div className="main_summaryUser">
          <div className="summary_header_main">
            <Header />
            <div className="summary_header">
              <Row style={{ width: "92%", paddingBottom: ".3em" }}>
                <Col lg={2} className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label
                      htmlFor="username"
                      className="user_id_text p-0 ml-1 m-0"
                    >
                      Jahr
                    </Form.Label>
                  </div>
                  <div>
                    <select
                      className="form-select inside_DropDown_customerSummary"
                      value={filters.selectedYear}
                      // onChange={(e) => setSelectedYear(e.target.value)}
                      onChange={(e) =>
                        updateFilter("selectedYear", e.target.value)
                      }
                    // defaultValue={2025}
                    >
                      {availableYears.map((item, index) => (
                        <option
                          value={item}
                          key={index}
                          className="inside_DropDown_customerSummary"
                        >
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col lg={2} className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label
                      htmlFor="username"
                      className="user_id_text p-0 ml-1 m-0"
                    >
                      Kd.nr
                    </Form.Label>
                  </div>
                  <div>
                    <MultiSelect
                      options={availableKdNumber || []}
                      value={filters.selectedKdNumber}
                      placeholder="Select"
                      onChange={(value) => updateFilter("selectedKdNumber", value)}
                    />
                  </div>
                </Col>
                <Col lg={2} className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label
                      htmlFor="username"
                      className="user_id_text p-0 ml-1 m-0"
                    >
                      Div
                    </Form.Label>
                  </div>
                  <div>
                    <MultiSelect
                      options={availableHandler || []}
                      value={filters.selectedHandler}
                      placeholder="Select"
                      onChange={(value) => updateFilter("selectedHandler", value)}
                    />
                  </div>
                </Col>
                <Col lg={2} className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label
                      htmlFor="username"
                      className="user_id_text p-0 ml-1 m-0"
                    >
                      Land
                    </Form.Label>
                  </div>
                  <div>
                    <MultiSelect
                      options={availableLand || []}
                      value={filters.selectedLand}
                      placeholder="Select"
                      onChange={(value) => updateFilter("selectedLand", value)}
                    />
                  </div>
                </Col>
                <Col lg={2} className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label
                      htmlFor="username"
                      className="user_id_text p-0 ml-1 m-0"
                    >
                      Active
                    </Form.Label>
                  </div>
                  <div>
                    <select
                      className="form-select inside_DropDown_customerSummary"
                      value={filters.selectedActive}
                      // onChange={(e) => setSelectedActive(e.target.value)}
                      onChange={(e) =>
                        updateFilter("selectedActive", e.target.value)
                      }
                    >
                      {availableActive &&
                        availableActive.map((item, index) => (
                          <option
                            value={item.value}
                            key={index}
                            className="inside_DropDown_customerSummary"
                          >
                            {item.label}
                          </option>
                        ))}
                    </select>
                  </div>
                </Col>
                <Col lg="auto" className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label className="user_id_text p-0 ml-1 m-0">
                      Type
                    </Form.Label>
                  </div>
                  <div>
                    <Form.Select
                      value={filters.selectedType}
                      // onChange={(e) => setSelectedType(e.target.value)}
                      onChange={(e) =>
                        updateFilter("selectedType", e.target.value)
                      }
                      className="form-select inside_DropDown_customerSummary"
                    >
                      <option
                        value=""
                        className="inside_DropDown_customerSummary"
                      >
                        EK/VK
                      </option>
                      <option
                        value="EK"
                        className="inside_DropDown_customerSummary"
                      >
                        EK
                      </option>
                      <option
                        value="VK"
                        className="inside_DropDown_customerSummary"
                      >
                        VK
                      </option>
                    </Form.Select>
                  </div>
                </Col>

                <Col lg="auto" className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label className="user_id_text p-0 ml-1 m-0">
                      VTR
                    </Form.Label>
                  </div>
                  <div>
                    <MultiSelect
                      options={vtr || []}
                      value={filters.selectedVtr}
                      onChange={(value) => updateFilter("selectedVtr", value)}
                      placeholder="Select"
                    />
                  </div>
                </Col>

                <Col lg="auto" className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label className="user_id_text p-0 ml-1 m-0">
                      VTR Group
                    </Form.Label>
                  </div>
                  <div>
                    <MultiSelect
                      options={vtrGroup || []}
                      value={filters.selectedVtrGroup}
                      onChange={(value) => updateFilter("selectedVtrGroup", value)}
                      placeholder="Select"
                    />
                  </div>
                </Col>
                <Col lg="auto" className="user_id_main1">
                  <div className="user_id_main_text">
                    <Form.Label className="user_id_text p-0 ml-1 m-0">
                      Planned Kd.
                    </Form.Label>
                  </div>
                  <div>
                    <select
                      className="form-select inside_DropDown_customerSummary"
                      value={filters.selectedPlanned}
                      // onChange={(e) => setSelectedPlanned(e.target.value)}
                      onChange={(e) =>
                        updateFilter("selectedPlanned", e.target.value)
                      }
                    >
                      <option value="*">*</option>
                      <option value="J">J</option>
                      <option value="N">N</option>
                    </select>
                  </div>
                </Col>

                <Col lg="auto" className="user_id_main1">
                  <div className="user_id_main_text">
                    <Form.Label className="user_id_text p-0 ml-1 m-0">
                      Handler Name
                    </Form.Label>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter"
                    className="inside_DropDown_customerSummary1"
                    value={filters.handlerName}
                    // onChange={(e) => setHandlerName(e.target.value)}
                    onChange={(e) =>
                      updateFilter("handlerName", e.target.value)
                    }
                  />
                </Col>

                <Col lg="auto" className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label className="user_id_text p-0 ml-1 m-0">
                      Select Vorgabe
                    </Form.Label>
                  </div>
                  <div className="customerSummary_Tepmate">
                    <div >
                      <select

                        value={filters.selectedTemplate}
                        onChange={(e) => {
                          const selectedValue = e.target.value;

                          // setSelectedTemplate(selectedValue);
                          updateFilter("selectedTemplate", selectedValue);

                          // empty select
                          if (!selectedValue) {
                            setTableCheckbox({});
                            // setBodyDataAllocateTemplate([]);
                            return;
                          }

                          const updatedCheckbox = {};
                          const shouldUncheck = !customerDetails.some(
                            (row) => row.jahresVk > 0
                          );

                          // console.log("shouldUncheck 938", shouldUncheck)
                          customerDetails.forEach((row, index) => {
                            // let jahresVkSoldTo = []
                            // jahresVkSoldTo.push(row.jahresVk === null)

                            // console.log(' jahresvk ', jahresVkSoldTo)

                            setIsSelectAllChecked(shouldUncheck);

                            updatedCheckbox[index] = {
                              checked: row.jahresVk === null ? true : false,
                              soldTo: row.soldTo,
                              planYear: row.year,
                              division: row.div,
                              shipTo: row.shipTo,
                              jahresVk: row.jahresVk, // add state jahresVk value
                            };

                            // bodyArray.push({
                            //   soldTo: row.soldTo,
                            //   shipTo: row.shipTo,
                            //   div: row.div,
                            //   templateDes: selectedItem?.description || "",
                            //   year: row.year,
                            // });
                          });

                          setTableCheckbox(updatedCheckbox);

                          // api body
                          // setBodyDataAllocateTemplate(bodyArray);
                        }}
                        className="form-select inside_DropDown_customerSummary1"
                      >
                        <option value="">Select</option>

                        {customerSummaryTemplateData?.map((item, index) => (
                          <option key={index} value={item.soldTo}>
                            {item.description} | {item.division} | {item.soldTo}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="save_template_main">
                      <button
                        type="button"
                        className="btn btn-success customerSummaryBtn"
                        onClick={onSaveTemplate}
                        style={{ width: "60px" }}
                      >
                        {isLoadingSave ? (
                          <div id="loading_both">
                            <i
                              id="spinner"
                              className="fa fa-spinner fa-spin"
                            ></i>
                          </div>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </Col>

                <Col lg="auto" className="user_id_main">
                  <div className="user_id_main_text">
                    <Form.Label htmlFor="oldCustomerControl" className="user_id_text p-0 ml-1 m-0">
                      Control Old Customer
                    </Form.Label>
                  </div>
                  <div className="customerSummary_Tepmate">
                    <div>
                      <select
                        id="oldCustomerControl"
                        value={filters.selectedOldCustomer || "J"}
                        onChange={(e) =>
                          updateFilter("selectedOldCustomer", e.target.value)
                        }
                        className="form-select inside_DropDown_customerSummary"
                      >
                        <option value="J">J</option>
                        <option value="N">N</option>
                      </select>
                    </div>
                  </div>
                </Col>

                {/*  */}

                {/*  */}
              </Row>
              <Row style={{ width: "12%", paddingBottom: ".3em" }}>
                <div className="fixed_action_btns">
                  {
                    (parsedUser?.admin === true || parsedUser?.subadmin === true) &&
                    <Col className="reset_btn_main" lg="auto">

                      <button
                        type="button"
                        className="btn btn-danger d-flex justify-content-center align-items-center reset-btn"
                        id="modify_delete_btn"
                        onClick={deleteMultiplePlannings}
                        style={{ width: "65px", fontSize: "13px", margin: "0px" }}
                      >
                        {isLoadingDelete ? (
                          <div id="loading_both">
                            <i id="spinner" className="fa fa-spinner fa-spin"></i>
                          </div>
                        ) : (
                          "Löschen"
                        )}
                      </button>

                    </Col>}
                  <Col className="reset_btn_main" lg="auto">
                    <button
                      type="button"
                      className="btn btn-danger d-flex justify-content-center align-items-center reset-btn"
                      id="modify_reset_btn"
                      onClick={getResetValue}
                      style={{ width: "85px", fontSize: "13px" }}
                    >
                      Zurücksetzen
                    </button>
                  </Col>
                </div>
              </Row>
            </div>
          </div>

          {/* DataTable component directly inside ModifyUser */}

          {pageNo === 0 && isLoadingCustDetails ? (
            <div className="loader_in_summary">
              <Loader />
            </div>
          ) : (
            <div className="summary_table_main">
              {customerDetails?.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "10em",
                    fontWeight: "500",
                    fontSize: "20px",
                    color: "gray",
                    fontStyle: "italic",
                  }}
                >
                  No data found. Please try again later...
                </div>
              ) : (
                <div
                  ref={scrollRef}
                  className="table-scroll-container"
                  onScroll={handleInfinityScroll}
                >
                  <table className="customer-table">
                    <thead>
                      <tr>
                        <th>
                          <div className="customer_table_data_checkbox">
                            <input
                              className="customerSummary_Checkbox"
                              type="checkbox"
                              // checked={
                              //   customerDetails?.length > 0 &&
                              //   customerDetails.every((row, index) => {
                              //     const shouldUncheck =
                              //       filters.selectedTemplate &&
                              //       row.jahresVk !== null &&
                              //       row.jahresVk !== 0;

                              //     if (shouldUncheck) {
                              //       return false;
                              //     }

                              //     return tableCheckbox[index]?.checked;
                              //   })
                              // }
                              checked={isSelectAllChecked}
                              onChange={handleSelectAllCheckboxes}
                            />
                            S.No
                          </div>
                        </th>
                        <th style={{ textAlign: "center" }}>Jahr</th>
                        <th>Land</th>
                        <th>Kd.nr.</th>
                        <th>L.adr.ID</th>
                        <th style={{ textAlign: "center" }}>Division</th>
                        <th>Handler-Name</th>
                        <th>Ort</th>
                        <th style={{ textAlign: "center" }}>Shop-Typ</th>
                        <th>Plan-Typ</th>
                        <th style={{ textAlign: "center" }}>Active</th>
                        <th style={{ textAlign: "center" }}>Template</th>
                        <th>VTR</th>
                        <th style={{ textAlign: "right" }}>
                          Plan VK-Wert
                          <br />
                          <span id="totalVK">
                            {formatGermanInputForDecimal(totalVK, 11)}
                          </span>
                        </th>

                        <th>Ist VK-Wert</th>
                        <th style={{ textAlign: "right" }}>
                          Plan EK-Wert
                          <br />
                          <span id="totalEK">
                            {formatGermanInputForDecimal(totalEK, 11)}
                          </span>
                        </th>
                        <th>Ist EK-Wert</th>
                        <th> NOS Refill</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerDetails?.map((row, index) => {
                        const isSelected =
                          selectedCustomer &&
                          row.soldTo === selectedCustomer.soldTo &&
                          row.shipTo === selectedCustomer.shipTo &&
                          row.year === selectedCustomer.year &&
                          row.div === selectedCustomer.div;
                        // const isLocked = isSelected && LockTime && currentTime < LockTime; // still within lock window
                        // console.log("isSelected render", isSelected)
                        return (
                          <tr
                            key={index}
                            onClick={() => handleSelectCustomer(row)}
                            className={
                              isSelected ? "customer-selected-row" : ""
                            }
                          >
                            <td
                              className="customer_table_data"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color  customer_table_data_checkbox"
                                  : "customer_table_data_checkbox"
                              }
                              // style={{
                              //   color: filters.selectedOldCustomer === "J" ? "red" : "black",
                              // }}
                              >

                                <input
                                  className="customerSummary_Checkbox"
                                  type="checkbox"
                                  // checked={tableCheckbox[index]?.checked || false}
                                  checked={
                                    filters.selectedTemplate &&
                                      row.jahresVk !== null &&
                                      row.jahresVk !== 0
                                      ? false
                                      : tableCheckbox[index]?.checked || false
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) =>
                                    handleSelectCheckboxes(e, row, index)
                                  }
                                />
                                {index + 1}
                                {isSelected ? (
                                  <div className="lock-status-customer-summary">
                                    <i className="fa-solid fa-lock"></i>
                                  </div>
                                ) : null}
                              </div>
                            </td>
                            <td className={
                              filters.selectedOldCustomer === "J"
                                ? "control_old_customer_change_color"
                                : "customer_table_data"
                            }
                            // style={{
                            //   color: filters.selectedOldCustomer === "J" ? "red" : "black",
                            // }}
                            >{row.year}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.cust}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.soldTo}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.shipTo}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : "customer_table_data"
                              }
                            >{row.div}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.name}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.cty}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.shopType}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.pTyp}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.active}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >
                              {row.templateDes}
                            </td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : ""
                              }
                            >{row.vtr}</td>
                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : "customer_table_data"
                              }
                            >
                              {row.jahresVk === null || row.jahresVk === 0
                                ? ""
                                : formatGermanInputForDecimal(row.jahresVk, 10)}
                            </td>

                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : "customer_table_data"
                              }
                            >
                              {row.lastYearSelling === null ||
                                row.lastYearSelling === 0
                                ? ""
                                : formatGermanInputForDecimal(
                                  Math.round(row.lastYearSelling),
                                  10
                                )}
                            </td>

                            <td
                              className={
                                filters.selectedOldCustomer === "J"
                                  ? "control_old_customer_change_color"
                                  : "customer_table_data"
                              }
                            >
                              {row.jahresEk === null || row.jahresEk === 0
                                ? ""
                                : formatGermanInputForDecimal(row.jahresEk, 10)}
                            </td>
                            <td className={
                              filters.selectedOldCustomer === "J"
                                ? "control_old_customer_change_color"
                                : "customer_table_data"
                            }
                            >
                              {row.lastYearBuying === null ||
                                row.lastYearBuying === 0
                                ? ""
                                : (formatGermanInputForDecimal(Math.round(row.lastYearBuying),
                                  10
                                ))}
                            </td>
                            <td
                              style={{ textAlign: "center", cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();

                                // CTYP empty ho to navigate nahi hoga
                                if (!row.CTYP || row.CTYP.trim() === "") {
                                  return;
                                }

                                console.log("Re-Fill clicked for row:", row);

                                navigate("/re-fill", {
                                  state: { fromCustomerSummary: true, row },
                                });
                              }}
                            >
                              <div
                                className={
                                  filters.selectedOldCustomer === "J"
                                    ? "control_old_customer_change_color"
                                    : ""
                                }
                              >
                                {row.CTYP != null && row.CTYP.trim() !== "" && (
                                  <i className="fa-solid fa-basket-shopping"></i>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {isLoadingCustDetails && (
                    <div className="table-loader">
                      <div
                        className="spinner-border text-secondary"
                        role="status"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        <Footer className="footer" />
      </div >
    </>
  );
};

export default CustomerSummary;
